export default __webpack_public_path__ + "static/media/Logo_Trust_SAS@3x.45ce47ee.png";